import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import siteconfig from '../site.config'
import validations from './plugins/validations.js'

Vue.use(Vuex)

const initialUserData = {
  voornaam : '',
  achternaam : '',
  telefoon : '',
  emailadres : '',
  postcode : '',
  straatnaam : '',
  huisnummer : '',
  toevoeging : '',
  bezit_koophuis: true,
  use_exact_verbruik: true,
  exact_verbruik : false,
  people_verbruik : 2,
  option_aanbod : false,
  option_voorwaarden : false,
  pipedrivestate: 0,  // 0 => not send, 1 => sending, 2 => send compleet
};

export default new Vuex.Store({
  state: {
    pipedrive : null,
    pipedrive_planner_url : false,
    currentStep : 1, 
    completedSteps : [], // empty after development
    userData : JSON.parse(JSON.stringify(initialUserData)), // Keep constant clean
    energieVerbruik : {
      1 : 1925,
      2 : 3005,
      3 : 3605,
      4 : 4155,
      5 : 4375,
      6 : 4385
    },
  },

  getters: {
    get_estimated_verbruik : state => {
      if( state.userData.use_exact_verbruik ) 
        return state.userData.exact_verbruik
      return state.energieVerbruik[state.userData.people_verbruik]
    },

    get_current_step : state => {
      return state.currentStep
    },

    get_completed_steps : state => {
      return state.completedSteps
    },

    is_completed_step : (state) => (index) => {
      return state.completedSteps.includes(index) 
    },

    get_pipedrive_state : state => {
      return state.userData.pipedrivestate
    },

    pipedrive_planner_url : state => {
      return state.pipedrive_planner_url
    }
  },

  mutations: {
    SETSTEP( state, index ) {
      state.currentStep = index
      if( (index > 1) && (state.currentStep < index) ) {
        if (typeof dataLayer !== 'undefined') {
          dataLayer.push({
            'event': 'gtm-event',
            'category': 'Offerte aanvragen',
            'action': 'Form view',
            'label': 'Step ' + index,
            'value': ''
          });
        }
      }
    },

    COMPLETESTEP( state, index ) {
      if( !state.completedSteps.includes(index) ) {
        state.completedSteps.push(index)
      }
    },

    UNCOMPLETESTEP( state, index ) {
      if( state.completedSteps.includes(index) ) {
        let arrayindex = state.completedSteps.indexOf(index)
        state.completedSteps.splice(arrayindex, 1)
      }
    },

    UPDATEUSER( state, data ) {
      state.userData[data.fieldname] = data.value
    },

    RESETSTATE( state ) {
      for( let elem in initialUserData ) {
        state.userData[elem] = initialUserData[elem]
      }
      // state.currentStep = 1
      state.completedSteps = []
    },

    PIPEDRIVESTATE( state, pds ) {
      state.userData.pipedrivestate = pds
    },

    SETPLANNERURL( state, plannerurl ) {
      state.pipedrive_planner_url = plannerurl
    },

  },

  actions: {
    set_step_to( {commit}, index ) {
      commit('SETSTEP', index)
    },

    check_step_1( {commit} ) {
      if( validations.zipcode_nl(this.state.userData.postcode) && 
       (this.state.userData.huisnummer.length > 0) &&
       (this.state.userData.bezit_koophuis == true) ) {
        commit('PIPEDRIVESTATE', 0)
        commit('COMPLETESTEP', 1)
       } else {
        commit('UNCOMPLETESTEP', 1)
       }
    },

    check_step_2( {commit} ) {
      if( this.state.userData.use_exact_verbruik ) {
        if( this.state.userData.exact_verbruik > 0 ) {
          commit('PIPEDRIVESTATE', 0)
          commit('COMPLETESTEP', 2)
        } else {
          commit('UNCOMPLETESTEP', 2)
        }
      } else {
        commit('COMPLETESTEP', 2)
      }
    },

    check_step_3( {commit} ) {
      if( (this.state.userData.option_voorwaarden == true) && 
          (validations.phonenumber_nl(this.state.userData.telefoon)) &&
          (validations.email(this.state.userData.emailadres)) ) {
        commit('PIPEDRIVESTATE', 1)
        commit('COMPLETESTEP', 3)
      } else {
        commit('UNCOMPLETESTEP', 3)
      }
    },

    update_userdata_for( {commit, dispatch}, data ) {
      commit('UPDATEUSER', data)
      if( data.step == 1) dispatch( 'check_step_1', {root: true})
      if( data.step == 2) dispatch( 'check_step_2', {root: true})
      if( data.step == 3) dispatch( 'check_step_3', {root: true})
    },

    get_planner_url( {commit} ){
      // get dynamic url for planner
      axios.get(siteconfig.wp_api + '/wp-json/v2/plannerurl/')
        .then( function(response) {
          let plannerurl = JSON.parse(response.data)
          if( plannerurl !== undefined && plannerurl ) {
            commit( 'SETPLANNERURL', plannerurl)
          } else {
            console.log('Planner (json) niet gevonden')
          }
        })
        .catch((error) => {
          console.log('Planner (url) niet gevonden')
        })
    },

    to_pipedrive( {commit, getters, state, dispatch} ) {
      // dispatch('reset_state')
      // commit( 'PIPEDRIVESTATE', 2)
      // return // DEBUG!!!
      axios.post(siteconfig.wp_api + '/wp-json/v2/log/', {
        email : state.userData.emailadres
      })

      var
        api_url = siteconfig.pipedrive_api,
        token = '?api_token=' + siteconfig.pipedrive_api_token

      var
        volledigenaam = state.userData.voornaam + ' ' + state.userData.achternaam,
        address = state.userData.postcode + ', nederland, ' + state.userData.huisnummer  + ' ' + state.userData.toevoeging,
        verbruik = getters.get_estimated_verbruik,
        // organisatie = 1,
        lead_bron = 10, // 10=website, 11=zonnefabriek, 12=mijnDomein
        omschrijving_deal = volledigenaam + ' deal',
        pipeline_stageid = 1 // 1=leadofferte

      //  Add person
      axios.post( api_url + 'persons/' + token, {
          name : volledigenaam,
          email : state.userData.emailadres,
          phone : state.userData.telefoon,
          // org_id : organisatie,
          'd4aa39546d22a46df36bbf668bf044c646c9eeb6' : state.userData.voornaam,
          '3ec37996c7b649b8c9716f524bbfd9ea7af6f0f0' : state.userData.achternaam,
          'd8b83c3bcf3727f8ca1eeddd41218bf974de3486' : state.userData.postcode,
          'c7d753607d8742ec0945164b15f79d977735a809' : address,
          '250c5032a17a3467bcb5db3c6eb562b1b27a0d2a' : state.userData.straatnaam,
          'fccc3a38eca0730f125d6dd5b2027be3946aa5cf' : state.userData.huisnummer,
          'd6fadc6acb4c8692db3da62d17492d58a0424b28' : state.userData.toevoeging,
          '3b0fc3b77d178b051203411abf711cfafe4625d1' : lead_bron,
          'a98841208f064effbf870d001a765dabe2078c76' : verbruik,
          'f97ed91d4cef4b8b9f3fee27227772c0992d25fb' : state.userData.option_aanbod == true ? 'Ja' : 'Nee'
        })
        .then( function(response) {
          //  Add deal to person
          let person_id = response.data.data.id
          axios.post( api_url + 'deals/' + token, {
            title: omschrijving_deal,
            person_id : person_id,
            stage_id : pipeline_stageid, // lead offerte
            '075f5904046c19d3ef6ba947d831b4437f359ad2' : address,
            // org_id : organisatie,
            // '58844031fa1258d01f94ba3dc78ec8851bfd49de' : state.userData.option_aanbod ? 'ja' : 'nee'
          })
          .then( function(response) {
            dispatch('reset_state')
            commit( 'PIPEDRIVESTATE', 2)
            if (typeof dataLayer !== 'undefined') {
              dataLayer.push({
                'event': 'gtm-event',
                'category': 'Offerte aanvragen',
                'action': 'Form submit',
                'label': '',
                'value': ''
              });
            }
          })
          .catch((error) => {
            commit( 'PIPEDRIVESTATE', 0)
            if (error.response) {
              // console.log( 'response data : ');   console.log(error.response.data);
              // console.log( 'response status : '); console.log(error.response.status);
              // console.log( 'response headers : '); console.log(error.response.headers);
            } else if (error.request) {
                // console.log(error.request);
            } else {
                // console.log('Error', error.message);
            }
          })
        })
        .catch((error) => {
          commit( 'PIPEDRIVESTATE', 0)
          if (error.response) {
            // console.log( 'response data : ');   console.log(error.response.data);
            // console.log( 'response status : '); console.log(error.response.status);
            // console.log( 'response headers : '); console.log(error.response.headers);
          } else if (error.request) {
              // console.log(error.request);
          } else {
              // console.log('Error', error.message);
          }
        })
    },

    reset_state( { commit } ) {
      commit('RESETSTATE')
    }
  }
})
